{
  "page": {
    "title": "โปรโมชั่น"
  },
  "toolbar": {
    "create": "โปรโมชั่นใหม่",
    "search_placeholder": "ค้นหาโปรโมชั่นหรือหมายเหตุ",
    "export": "ส่งออก",
    "all_sellers": "ผู้ขายทั้งหมด",
    "date_range_placeholder": "เลือกช่วงวันที่",
    "date_range_apply": "ใช้",
    "date_range_clear": "ล้าง"
  },
  "create": {
    "title": "โปรโมชั่นใหม่",
    "subtitle": "สร้างโครงโปรโมชั่นก่อน แล้วจึงเพิ่มกฎของแถมในตัวสร้าง",
    "campaign_label": "แคมเปญ",
    "campaign_placeholder": "เลือกแคมเปญ",
    "name_label": "ชื่อโปรโมชั่น",
    "name_placeholder": "เช่น Songkran GWP — Shopee",
    "marketplace_label": "มาร์เก็ตเพลส",
    "seller_label": "รหัสผู้ขาย",
    "seller_placeholder": "เช่น seller-1",
    "start_label": "เริ่ม",
    "end_label": "สิ้นสุด",
    "rule_mode_label": "โหมดกฎ",
    "cancel": "ยกเลิก",
    "submit": "สร้างโปรโมชั่น",
    "err_campaign_required": "ต้องระบุแคมเปญ",
    "err_start_required": "ต้องระบุวันเริ่ม",
    "err_end_required": "ต้องระบุวันสิ้นสุด"
  },
  "column": {
    "activate": "เปิดใช้งาน",
    "status": "สถานะ",
    "name": "ชื่อโปรโมชั่น",
    "seller": "ผู้ขาย",
    "period": "ช่วงเวลา",
    "progress": "ความคืบหน้า",
    "quota": "โควต้า",
    "created_by": "สร้างโดย",
    "note": "หมายเหตุ",
    "draft_group": "ฉบับร่าง · {{count}} ช่องทาง"
  },
  "status": {
    "draft": "ฉบับร่าง",
    "active": "กำลังใช้งาน",
    "finish": "สิ้นสุดแล้ว",
    "archived": "เก็บถาวร"
  },
  "filter": {
    "all_statuses": "ทุกสถานะ",
    "all_marketplaces": "ทุกมาร์เก็ตเพลส",
    "date_from": "ตั้งแต่",
    "date_to": "ถึง"
  },
  "activate": {
    "label": "เปิดใช้งาน {{name}}",
    "activated": "เปิดใช้งานโปรโมชั่นแล้ว",
    "finished": "สิ้นสุดโปรโมชั่นแล้ว",
    "deactivated": "ย้ายโปรโมชั่นเป็นฉบับร่างแล้ว",
    "reopened": "เปิดโปรโมชั่นกลับเป็นฉบับร่างแล้ว",
    "locked": "โปรโมชั่นที่สิ้นสุดแล้วไม่สามารถเปิดใช้งานใหม่ได้"
  },
  "footer": {
    "showing": "แสดง {{shown}} จาก {{total}} โปรโมชั่น"
  },
  "export_done": "ส่งออก {{count}} โปรโมชั่นแล้ว",
  "bulk": {
    "selected": "เลือก {{count}} รายการ",
    "activate": "เปิดใช้งาน",
    "finish": "สิ้นสุด",
    "archive": "เก็บถาวร",
    "clear": "ล้างการเลือก"
  },
  "action": {
    "activate": "เปิดใช้งาน",
    "clone": "ทำสำเนา",
    "reopen": "เปิดกลับเป็นฉบับร่าง",
    "reopen_hint": "ย้ายกลับเป็นฉบับร่างเพื่อแก้ไข",
    "reopen_blocked_tooltip": "โปรโมชั่นนี้มีการแลกรับแล้ว — กรุณาทำสำเนาเพื่อใช้งานใหม่แทน",
    "delete": "ลบ",
    "edit": "แก้ไข"
  },
  "detail": {
    "title": "ตัวสร้างโปรโมชั่น",
    "back": "กลับไปยังโปรโมชั่น",
    "draft": "ฉบับร่าง",
    "field": {
      "campaign": "แคมเปญ",
      "name": "ชื่อโปรโมชั่น (จำเป็น)",
      "marketplace": "มาร์เก็ตเพลส",
      "seller": "ผู้ขาย",
      "note": "หมายเหตุ",
      "note_en": "คำอธิบาย (EN)",
      "note_th": "คำอธิบาย (ไทย)",
      "note_en_placeholder": "English description",
      "note_th_placeholder": "คำอธิบายภาษาไทย",
      "active_period": "ช่วงเวลาที่ใช้งาน",
      "rule_mode": "โหมดกฎ",
      "payment_method": "วิธีชำระเงิน",
      "trigger_product": "สินค้าทริกเกอร์",
      "trigger_skus": "SKU ทริกเกอร์",
      "min_spend": "ยอดขั้นต่ำ",
      "gift_sku": "SKU ของแถม",
      "quantity": "จำนวน",
      "total_gift_quota": "โควต้าของแถมทั้งหมด",
      "gift_cap_mode": "โหมดจำกัดของแถม"
    },
    "rule_mode": {
      "stack_all": "ใช้ทุกกฎ",
      "first_match": "กฎแรกที่ตรงเท่านั้น"
    },
    "gift_cap": {
      "per_order": "หนึ่งของแถมต่อออเดอร์",
      "per_item": "หนึ่งของแถมต่อชิ้น"
    },
    "payment": {
      "any": "ทุกแบบ",
      "cod": "เก็บเงินปลายทาง",
      "non_cod": "ไม่เก็บปลายทาง"
    },
    "column": {
      "trigger": "ซื้อ",
      "gift_addon": "รับของแถม",
      "constraints": "เงื่อนไข"
    },
    "section": {
      "basics": "ข้อมูลพื้นฐาน",
      "targeting": "การกำหนดเป้าหมาย",
      "rule_mode": "โหมดกฎ"
    },
    "rule_mode_note": "ใช้ทุกกฎ: ทุกกฎที่ตรงเงื่อนไขจะทำงานและผู้ซื้อจะได้รับของแถมทั้งหมดที่ตรงเงื่อนไข กฎแรกที่ตรง: การประเมินจะหยุดที่กฎแรกที่ผ่านเงื่อนไข",
    "activate_note": "เปิดใช้งานจากหน้ารายการโปรโมชั่น",
    "clone_saved_first": "กรุณาบันทึกโปรโมชั่นก่อนทำสำเนาไปมาร์เก็ตเพลสอื่น",
    "cloned": "ทำสำเนาโปรโมชั่นเป็นฉบับร่างใหม่แล้ว",
    "empty_gifts": "ยังไม่มีของแถม",
    "add_rule": "เพิ่มกฎอีกข้อ"
  },
  "rule": {
    "title": "กฎข้อที่ {{n}}",
    "move_up": "เลื่อนขึ้น",
    "move_down": "เลื่อนลง",
    "expand": "ขยายกฎ",
    "collapse": "ย่อกฎ",
    "add_sku": "เพิ่ม SKU",
    "add_gift": "เพิ่มของแถม",
    "exclude_min_spend": "ยกเว้นจากยอดขั้นต่ำ"
  },
  "builder": {
    "save": "บันทึก",
    "save_draft": "บันทึกฉบับร่าง",
    "saved": "บันทึกโปรโมชั่นแล้ว",
    "linked_group_banner": "ฉบับร่าง · กำลังแก้ไข {{count}} ช่องทาง",
    "activate_for_n_channels": "เปิดใช้งานสำหรับ {{count}} ช่องทาง",
    "trigger_type": {
      "label": "ใช้กับ",
      "all": "SKU ทั้งหมด",
      "specific": "SKU ที่ระบุ"
    },
    "trigger_sku_count": "SKU ({{count}})",
    "pick_by_product": "เลือกสินค้าทริกเกอร์",
    "pick_by_sku": "เพิ่ม SKU ทริกเกอร์",
    "gift_expands_to": "ตัดสต็อกฐาน",
    "add_on": {
      "single_sku_hint": "ของแถมแบบ SKU เดี่ยว — จองสต็อกโดยตรง ไม่มีการแตกชุด"
    },
    "is_min_spend": "กำหนดยอดซื้อขั้นต่ำ",
    "min_spend_value": "ยอดซื้อขั้นต่ำ (บาท)",
    "discount": {
      "label": "ส่วนลด",
      "include": "นับรวมในยอดที่เข้าเงื่อนไข",
      "exclude": "หักออกจากยอดที่เข้าเงื่อนไข",
      "include_short": "นับรวม",
      "exclude_short": "ไม่นับรวม"
    },
    "shipping_fee": {
      "label": "ค่าจัดส่ง",
      "include": "นับรวมในยอดที่เข้าเงื่อนไข",
      "exclude": "ไม่นับรวมในยอดที่เข้าเงื่อนไข",
      "include_short": "นับรวม",
      "exclude_short": "ไม่นับรวม"
    },
    "gift_limit_type": {
      "label": "โหมดจำกัดของแถม",
      "per_order_short": "ต่อออเดอร์",
      "per_item_short": "ต่อชิ้น"
    },
    "gift_limit_quantity": "โควต้าของแถม",
    "gift_used_offset": "ใช้ไปแล้วก่อนย้ายมา Atlas",
    "gift_used_offset_hint": "นับเป็นยอดที่ใช้แล้ว ตั้งค่าตอนย้ายจากระบบเดิม",
    "gift_used_offset_toggle": "กำลังย้ายข้อมูลจากระบบเดิมอยู่หรือไม่?",
    "quota_used": "ใช้ไปแล้ว",
    "quota_remaining": "คงเหลือ",
    "quota_pct_used": "ใช้ไปแล้ว {{pct}}%",
    "quota_no_limit": "ไม่จำกัด",
    "add_sku_short": "เพิ่ม",
    "sku_paste": {
      "label": "วางรหัส SKU",
      "resolve": "ตรวจสอบ",
      "result": "พบ {{found}} รายการ, ไม่รู้จัก {{unrecognized}} รายการ"
    },
    "err_name_required": "กรุณากรอกชื่อโปรโมชั่น",
    "err_seller_required": "กรุณาระบุผู้ขาย",
    "err_dates": "วันสิ้นสุดต้องอยู่หลังวันเริ่มต้น",
    "err_no_rules": "กรุณาเพิ่มอย่างน้อยหนึ่งกฎ",
    "err_no_trigger_or_min_spend": "เพิ่ม SKU ทริกเกอร์ หรือกำหนดยอดซื้อขั้นต่ำสำหรับกฎแบบทั้งร้าน",
    "err_no_gift": "กรุณาเพิ่มอย่างน้อยหนึ่ง SKU ของแถม",
    "err_min_spend_required": "กรุณากรอกยอดขั้นต่ำมากกว่า 0",
    "err_trigger_n_required": "กรุณาระบุจำนวนทริกเกอร์ที่ต้องตรง",
    "err_sku_required": "กรุณาระบุ SKU",
    "err_money_format": "จำนวนต้องเป็นตัวเลขที่มีทศนิยมไม่เกิน 2 ตำแหน่ง",
    "err_money_negative": "จำนวนต้องไม่ติดลบ",
    "err_gift_used_offset_negative": "จำนวนที่ใช้ไปแล้วต้องไม่ติดลบ",
    "err_cannot_save": "ยังบันทึกไม่ได้",
    "err_fix_required": "กรุณาแก้ไขช่องที่ทำเครื่องหมายไว้ก่อนบันทึก"
  },
  "picker": {
    "title": "เลือก SKU",
    "subtitle_single": "ค้นหาหรือวางรหัส แล้วเลือก SKU ของแถมหนึ่งรายการ",
    "subtitle_multi": "ค้นหาหรือวางรหัส แล้วเลือก SKU ที่ต้องการเพิ่ม",
    "add": "เพิ่ม {{count}} รายการ",
    "cancel": "ยกเลิก",
    "tab_search": "ค้นหา",
    "tab_paste": "วางรหัส",
    "search_label": "ค้นหา SKU",
    "search_placeholder": "ค้นหาด้วยชื่อสินค้า…",
    "search_empty": "พิมพ์เพื่อค้นหาแคตตาล็อก SKU",
    "search_loading": "กำลังค้นหา…",
    "search_no_results": "ไม่พบ SKU ที่ตรงกับการค้นหา",
    "selected_count": "เลือกแล้ว {{count}} รายการ"
  },
  "precheck": {
    "title": "ตรวจสอบก่อนเปิดใช้งาน",
    "passed": "พร้อมเปิดใช้งาน",
    "blocked": "กรุณาแก้ไขรายการต่อไปนี้ก่อนเปิดใช้งาน:",
    "activate": "เปิดใช้งาน",
    "checking": "กำลังตรวจสอบ…",
    "activated": "เปิดใช้งานโปรโมชั่นแล้ว",
    "rule_prefix": "กฎข้อที่ {{n}}",
    "toast_blocked": "ไม่สามารถเปิดใช้งาน {{name}} ได้:",
    "reason": {
      "no_rules": "เพิ่มกฎอย่างน้อย 1 ข้อ",
      "missing_add_on": "เพิ่ม SKU ของแถมอย่างน้อย 1 รายการ",
      "invalid_dates": "วันสิ้นสุดต้องอยู่หลังวันเริ่มต้น",
      "quota_zero": "จำนวนของแถมสูงสุดต้องมีค่าอย่างน้อย 1",
      "missing_trigger_or_min_spend": "กฎแบบทั้งร้าน (ไม่มี SKU เงื่อนไข) ต้องกำหนดยอดซื้อขั้นต่ำ"
    }
  },
  "simulate": {
    "title": "จำลองตะกร้าสินค้า",
    "add_line": "เพิ่มรายการ",
    "sku": "SKU",
    "quantity": "จำนวน",
    "unit_price": "ราคาต่อหน่วย (บาท)",
    "discount": "ส่วนลด (บาท)",
    "shipping": "ค่าจัดส่ง (บาท)",
    "total_paid": "ยอดที่ต้องชำระ",
    "is_cod": "เก็บเงินปลายทาง",
    "run": "เริ่มการจำลอง",
    "empty_title": "ดูตัวอย่างโปรโมชั่น",
    "empty": "กรอกตะกร้าตัวอย่างด้านบน แล้วกด Run เพื่อดูกฎที่ทำงานและของแถมที่ได้รับ",
    "fired_rules": "กฎที่ทำงาน",
    "no_fire": "ไม่มีกฎทำงานสำหรับตะกร้านี้",
    "min_spend_math": "การตรวจสอบยอดขั้นต่ำ",
    "subtotal": "ยอดรวม",
    "threshold": "เกณฑ์ขั้นต่ำ",
    "base": "ฐานเปรียบเทียบ",
    "passed": "ผ่าน",
    "failed": "ไม่ผ่าน",
    "gifts_awarded": "ของแถมที่ได้รับ",
    "remove_line": "ลบรายการ",
    "err_no_lines": "กรุณาเพิ่มอย่างน้อยหนึ่งรายการในตะกร้า",
    "err_sku_required": "กรุณาระบุ SKU",
    "err_money_format": "จำนวนต้องเป็นตัวเลขที่มีทศนิยมไม่เกิน 2 ตำแหน่ง",
    "err_money_negative": "จำนวนต้องไม่ติดลบ"
  },
  "report": {
    "title": "รายงานโปรโมชั่น",
    "subtitle": "การใช้โควต้าของแถมแยกตาม SKU",
    "search_placeholder": "ค้นหา SKU หรือชื่อ…",
    "all_platforms": "ทุกแพลตฟอร์ม",
    "all_shops": "ทุกร้าน",
    "all_time": "ทุกช่วงเวลา",
    "month_label": "เดือน",
    "column": {
      "sku": "SKU",
      "name": "ชื่อ SKU",
      "marketplace": "แพลตฟอร์ม",
      "shop": "ร้าน",
      "quota": "โควต้า",
      "used": "ใช้แล้ว",
      "remaining": "เหลือ"
    },
    "export_csv": "ส่งออก .xlsx",
    "export_done": "ส่งออก {{count}} แถว",
    "empty_title": "ไม่พบแถวที่ตรงกัน",
    "empty_body": "ลองปรับตัวกรองแพลตฟอร์มหรือร้านค้า"
  },
  "redemption": {
    "title": "การแลกของแถมโปรโมชั่น",
    "subtitle": "ของแถมที่แจกทั้งหมด เรียงจากใหม่ไปเก่า",
    "redeemed": "แลกรับแล้ว",
    "order_copied": "คัดลอกรหัสออเดอร์แล้ว",
    "campaign_label": "แคมเปญ",
    "promotion_label": "โปรโมชั่น",
    "all_promotions": "ทุกโปรโมชั่น",
    "total_sets": "จำนวนชุดแลกรับทั้งหมด",
    "total_gift_qty": "จำนวนของขวัญทั้งหมด",
    "search_placeholder": "ค้นหาโปรโมชั่นหรือโน้ต…",
    "export": "ส่งออก",
    "clear": "ล้าง",
    "search": "ค้นหา",
    "export_done": "ส่งออก {{count}} รายการแลกรับ",
    "column": {
      "order_id": "รหัสออเดอร์",
      "promotion": "ชื่อโปรโมชั่น",
      "campaign": "ชื่อแคมเปญ",
      "seller": "ชื่อร้าน",
      "rule": "กฎ",
      "gwp_sku": "GWP",
      "gwp_quantity": "จำนวน",
      "redeem_set": "ชุดที่แลกรับ",
      "payment_date": "วันที่ชำระเงิน",
      "status": "สถานะ",
      "total_amount": "ยอดรวม (฿)"
    },
    "empty_title": "ไม่พบรายการแลกรับ",
    "empty_body": "รายการแลกรับจะปรากฏที่นี่เมื่อมีคำสั่งซื้อ",
    "all_campaigns": "ทุกแคมเปญ"
  },
  "seller_select": {
    "placeholder": "เลือกผู้ขาย",
    "empty": "ยังไม่มีร้านค้าที่เชื่อมต่อในช่องทางนี้",
    "stale": "{{id}} (ไม่ใช่ร้านที่เชื่อมต่ออยู่)",
    "option": "{{name}} ({{id}})"
  },
  "seller": {
    "disconnected_note": "This shop is disconnected. Atlas is no longer fetching its orders. The rule is kept and will apply again when the shop is reconnected."
  },
  "empty": {
    "title": "ยังไม่มีโปรโมชั่น",
    "body": "สร้างโปรโมชั่นเพื่อเริ่มแจกของแถม"
  },
  "performance": {
    "tabs_label": "มุมมองโปรโมชั่น",
    "tab_setup": "ตั้งค่า",
    "tab_performance": "ผลลัพธ์",
    "period_days": "{{n}} วัน",
    "period_day_of": "วันที่ {{day}} จาก {{total}}",
    "as_of": "ข้อมูล ณ {{time}}",
    "export": "ส่งออก CSV",
    "banner_running": "ยังดำเนินอยู่ · เหลืออีก {{n}} วัน · ตัวเลขอัปเดตเมื่อโหลดหน้า ล่าสุด {{time}}",
    "banner_in_transit": "สรุปผล · ยังมี {{n}} ออเดอร์อยู่ระหว่างขนส่ง (รวมใน GMV แล้ว)",
    "kpi": {
      "orders": "ออเดอร์",
      "gmv": "ยอดขาย",
      "abv": "มูลค่าเฉลี่ยต่อออเดอร์",
      "uplift": "มูลค่าเฉลี่ยต่อออเดอร์ที่เพิ่มขึ้น",
      "gifts": "ของแถมที่แจก",
      "so_far": "จนถึงตอนนี้",
      "orders_caption": "ที่ได้ของแถม",
      "gmv_caption": "ไม่รวมรายการของแถม",
      "abv_caption": "ต่อออเดอร์",
      "uplift_caption": "เทียบ {{baseline}} ของออเดอร์ที่ไม่ได้ของแถม · ช่วงเวลาและมาร์เก็ตเพลสเดียวกัน",
      "uplift_insufficient": "ต้องมีอย่างน้อย 30 ออเดอร์",
      "gifts_unused": "เหลือ {{n}} ชิ้น",
      "gifts_on_pace": "แนวโน้ม → ~{{n}}"
    },
    "col": {
      "brand": "แบรนด์ (AP)",
      "orders": "ออเดอร์",
      "units": "ชิ้น",
      "gmv": "ยอดขาย",
      "share": "สัดส่วน",
      "abv": "มูลค่าเฉลี่ยต่อออเดอร์",
      "gift_sku": "SKU ของแถม",
      "name": "ชื่อสินค้า",
      "qty": "จำนวน",
      "sku": "SKU"
    },
    "brand": {
      "title": "ยอดขายตามแบรนด์",
      "unmapped": "ยังไม่ระบุแบรนด์",
      "unmapped_skus": "{{n}} SKU",
      "unmapped_tip": "มี {{n}} SKU ที่ยังไม่ระบุแบรนด์ อัปโหลดไฟล์ CSV แบรนด์ที่ ตั้งค่า → SKU"
    },
    "gifts": { "title": "ของแถมที่แจก" },
    "top": {
      "title": "SKU ขายดี",
      "show_all": "แสดงทั้งหมด {{n}} รายการ",
      "show_less": "แสดง 10 อันดับแรก"
    },
    "total": "รวม",
    "empty": "ยังไม่มีการแลกของแถม",
    "empty_body": "ตัวเลขจะแสดงเมื่อมีออเดอร์ได้รับของแถมจากโปรโมชั่นนี้",
    "error": "โหลดผลลัพธ์ไม่สำเร็จ",
    "retry": "ลองใหม่",
    "report_link": "รายงานผลลัพธ์ →"
  }
}
